export const GET_LIST_CONTENT_MANAGEMENT_REQUEST = 'GET_LIST_CONTENT_MANAGEMENT_REQUEST'
export const GET_LIST_CONTENT_MANAGEMENT_SUCCESS = 'GET_LIST_CONTENT_MANAGEMENT_SUCCESS'
export const GET_LIST_CONTENT_MANAGEMENT_FAIL = 'GET_LIST_CONTENT_MANAGEMENT_FAIL'

export const GET_DETAIL_CONTENT_MANAGEMENT_REQUEST = 'GET_DETAIL_CONTENT_MANAGEMENT_REQUEST'
export const GET_DETAIL_CONTENT_MANAGEMENT_SUCCESS = 'GET_DETAIL_CONTENT_MANAGEMENT_SUCCESS'
export const GET_DETAIL_CONTENT_MANAGEMENT_FAIL = 'GET_DETAIL_CONTENT_MANAGEMENT_FAIL'

export const CREATE_CONTENT_MANAGEMENT_REQUEST = 'CREATE_CONTENT_MANAGEMENT_REQUEST'
export const CREATE_CONTENT_MANAGEMENT_SUCCESS = 'CREATE_CONTENT_MANAGEMENT_SUCCESS'
export const CREATE_CONTENT_MANAGEMENT_FAIL = 'CREATE_CONTENT_MANAGEMENT_FAIL'

export const UPDATE_CONTENT_MANAGEMENT_REQUEST = 'UPDATE_CONTENT_MANAGEMENT_REQUEST'
export const UPDATE_CONTENT_MANAGEMENT_SUCCESS = 'UPDATE_CONTENT_MANAGEMENT_SUCCESS'
export const UPDATE_CONTENT_MANAGEMENT_FAIL = 'UPDATE_CONTENT_MANAGEMENT_FAIL'

export const DELETE_CONTENT_MANAGEMENT_REQUEST = 'DELETE_CONTENT_MANAGEMENT_REQUEST'
export const DELETE_CONTENT_MANAGEMENT_SUCCESS = 'DELETE_CONTENT_MANAGEMENT_SUCCESS'
export const DELETE_CONTENT_MANAGEMENT_FAIL = 'DELETE_CONTENT_MANAGEMENT_FAIL'
